import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api/bff-prompts';
import { GetPromptByIdResponse } from '../../models/prompt-dto.model';

@Injectable({
  providedIn: 'root',
})
export class GetPromptService {
  constructor(private apiService: ApiService) {}

  getPromptsByUser(): Observable<GetPromptByIdResponse> {
    return this.apiService.get<GetPromptByIdResponse>(`prompt/`);
  }

  getPromptById(promptId: number): Observable<GetPromptByIdResponse> {
    return this.apiService.get<GetPromptByIdResponse>(`prompt/?id=${promptId}`);
  }
}
